import {Datagrid} from 'components/refinedev/Datagrid';
import {createColumnHelper} from '@tanstack/react-table';
import {LiveSearchFilter} from 'components/refinedev/filter-forms/LiveSearchFilter';
import {
  CreateButton,
  DeleteButtonWithConfirmation,
  EditButton,
} from 'components/refinedev/action_buttons';
import {defaultQueryOptions} from 'pages/_utils';
import {HttpError, useTable} from '@refinedev/core';
import StateBoundary from '@/components/basic/StateBoundary';
import { DataTable } from '@/components/data-table/data-table';
import { DataTableColumnHeader } from '@/components/data-table/data-table-column-header';
import DefaultDataTableToolbar from '@/components/refinedev/data-table/DefaultDataTableToolbar';
import useRefineTanstackDataTable from '@/hooks/refinedev/useRefineTanstackDataTable';

const thisResource = 'activity_logs';

const columnHelper = createColumnHelper<any>();

const columns = [
  columnHelper.accessor('id', {
    meta: {label: 'ID'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => info.getValue(),
  }),
  columnHelper.accessor('log_name', {
    meta: {label: 'Tên log'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => info.renderValue(),
  }),
  columnHelper.accessor('description', {
    meta: {label: 'Mô tả'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => info.renderValue(),
  }),
  columnHelper.accessor('subject_type', {
    meta: {label: 'Đối tượng'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => info.renderValue(),
  }),
  columnHelper.accessor('subject_id', {
    meta: {label: 'ID đối tượng'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => info.renderValue(),
  }),
  columnHelper.accessor('causer_id', {
    meta: {label: 'Người chỉnh sửa'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => info.renderValue(),
  }),
  columnHelper.accessor('updated_at', {
    meta: {label: 'Ngày cập nhật'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => info.renderValue(),
  }),
];

const ActivityLogList = () => {
  const {refineTable, tanstackTable} = useRefineTanstackDataTable({
    resource: thisResource,
    sorters: {initial: [{field: 'id', order: 'desc'}]},
    queryOptions: defaultQueryOptions,
  }, {columns});

  return (
    <StateBoundary
      isLoading={refineTable.tableQuery.isLoading}
      error={refineTable.tableQuery.error}>
      <div className="p-2">
        <DataTable
          table={tanstackTable}
          toolbar={
            <DefaultDataTableToolbar
              resource={thisResource}
              table={tanstackTable}
              createButton={false}
              // filters={
              //   <DataTableFilters defaultValues={{name: ''}} table={tanstackTable}>
              //     <TextInput source="name" label='Tên'/>
              //   </DataTableFilters>
              // }
            />
          }
        />
      </div>
    </StateBoundary>
  );
};

ActivityLogList.table_columns = columns;

export default ActivityLogList;
